import React, { useState } from "react";
import { PageHeader } from "@/components/UI";
import { Database, FilePdf, UploadSimple } from "@phosphor-icons/react";
import { BackupSection } from "./backup/BackupSection";
import { MonthlyReportSection } from "./backup/MonthlyReportSection";
import { ExcelImportSection } from "./backup/ExcelImportSection";

const TABS = [
  { id: "backup", label: "Yedek & Dışa Aktarım", icon: Database },
  { id: "report", label: "Aylık Yönetim Raporu", icon: FilePdf },
  { id: "import", label: "Excel İçe Aktarım", icon: UploadSimple },
];

export default function Backup() {
  const [tab, setTab] = useState("backup");

  return (
    <div data-testid="backup-page">
      <PageHeader
        title="Veri Yönetimi"
        subtitle="Yedekleme, aylık rapor üretimi ve Excel içe aktarım — tek merkezden."
      />

      <div className="flex flex-wrap gap-1 mb-6 border-b border-[#E5E2DC]">
        {TABS.map(t => (
          <button key={t.id} data-testid={`backup-tab-${t.id}`} onClick={() => setTab(t.id)}
            className={`px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px flex items-center gap-1.5 ${tab === t.id ? "border-[#1A1D1A] text-[#1A1D1A]" : "border-transparent text-[#6b746c] hover:text-[#1A1D1A]"}`}>
            <t.icon size={16} weight="duotone" /> {t.label}
          </button>
        ))}
      </div>

      {tab === "backup" && <BackupSection />}
      {tab === "report" && <MonthlyReportSection />}
      {tab === "import" && <ExcelImportSection />}
    </div>
  );
}

/* ---------------------------- YEDEKLEME ---------------------------- */
